import React from "react";
import { useNavigate } from "react-router";
import BackButton from "../forms/buttons/BackButton";
import Button from "../forms/buttons/Button";

/**
 * サブヘッダーコンポーネント
 * @param {string} title タイトル
 * @param {string} subTitle サブタイトル
 * @param {number} workId 作業ID
 * @param {string} onBack 戻るボタン押下時の処理
 * @class WorkHeader
 */
export default function WorkHeader({ title, subTitle, workId = null, onBack }) {
  const navigate = useNavigate();

  /**
   * 間接作業登録ページへ遷移
   * @memberof WorkHeader
   */
  const onIndirectCreate = () => {
    if (workId) {
      navigate(`/work-contents/create/indirect/${workId}`);
    }
  };
  /**
   * 無負荷作業登録ページへ遷移
   * @memberof WorkHeader
   */
  const onNoloadCreate = () => {
    navigate(`/work-contents/create/noload/${workId}`);
  };

  return (
    <div className="page-bar">
      <BackButton onClick={onBack} />

      <div className="page-title">
        <p className="eyebrow">{subTitle}</p>
        <h1>{title}</h1>
      </div>

      <div className="page-actions">
        <Button
          title="間接作業を追加"
          icon="plus"
          disabled={!workId}
          onClick={onIndirectCreate}
        />
        <Button
          title="無負荷作業を追加"
          icon="plus"
          disabled={!workId}
          onClick={onNoloadCreate}
        />
      </div>
    </div>
  );
}
